import { render, staticRenderFns } from "./ProjectDetailsView.vue?vue&type=template&id=511e7a29&"
import script from "./ProjectDetailsView.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsView.vue?vue&type=style&index=0&id=511e7a29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports